import React, { useState } from 'react';

var STEPS = [
  {
    icon: '📸',
    title: '차량등록증 사진만 올리세요',
    desc: '차량등록증 사진을 올리면 AI가 자동으로\n차량 정보를 인식합니다.',
    sub: 'OCR 인식 → 차량번호, 차대번호, 소유자, 주소 자동 입력'
  },
  {
    icon: '📄',
    title: '서류가 자동으로 만들어집니다',
    desc: '매매계약서, 말소신청서, 비사업용확인서\n3종이 자동 생성됩니다.',
    sub: '말소용 인보이스 + 사업자등록증까지 합본 PDF 제공'
  },
  {
    icon: '🚀',
    title: '바로 시작해보세요!',
    desc: '지금 바로 첫 차량을 등록해보세요.\n모든 기능을 무료로 사용할 수 있습니다.',
    sub: 'OCR 100건/월 무료 · 서류 무제한 생성'
  }
];

function OnboardingGuide({ companyId, onClose, onGoRegister }) {
  var [step, setStep] = useState(0);
  var s = STEPS[step];

  var dismiss = function() {
    try { localStorage.setItem('onboarding_done_' + companyId, '1'); } catch(e) {}
    onClose();
  };

  var goRegister = function() {
    dismiss();
    if (onGoRegister) onGoRegister();
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 99999 }}>
      <div style={{ background: '#fff', borderRadius: 20, width: 440, maxWidth: '92vw', padding: '32px 28px 24px', boxShadow: '0 20px 60px rgba(0,0,0,0.25)', textAlign: 'center', position: 'relative' }}>

        {/* Step indicators */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginBottom: 28 }}>
          {STEPS.map(function(_, i) {
            var active = i === step;
            var done = i < step;
            return (
              <div key={i} style={{
                width: 32, height: 32, borderRadius: '50%',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 14, fontWeight: 700,
                background: active ? '#1B3A5C' : done ? '#3b82f6' : '#e5e7eb',
                color: active || done ? '#fff' : '#94a3b8',
                transition: 'all 0.2s'
              }}>{i + 1}</div>
            );
          })}
        </div>

        {/* Icon */}
        <div style={{ fontSize: 56, marginBottom: 16, lineHeight: 1 }}>{s.icon}</div>

        {/* Title */}
        <h2 style={{ fontSize: 20, fontWeight: 800, color: '#0f172a', marginBottom: 10, letterSpacing: '-0.3px' }}>{s.title}</h2>

        {/* Description */}
        <p style={{ fontSize: 15, color: '#475569', lineHeight: 1.7, whiteSpace: 'pre-line', marginBottom: 6 }}>{s.desc}</p>

        {/* Sub text */}
        <p style={{ fontSize: 12, color: '#94a3b8', marginBottom: 28 }}>{s.sub}</p>

        {/* Buttons */}
        <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
          {step > 0 && (
            <button onClick={function() { setStep(step - 1); }} style={{
              padding: '11px 24px', borderRadius: 10, border: '1px solid #d0d5dd',
              background: '#fff', color: '#475569', fontSize: 14, fontWeight: 600,
              cursor: 'pointer'
            }}>&#8592; 이전</button>
          )}
          {step < STEPS.length - 1 ? (
            <button onClick={function() { setStep(step + 1); }} style={{
              padding: '11px 28px', borderRadius: 10, border: 'none',
              background: '#1B3A5C', color: '#fff', fontSize: 14, fontWeight: 700,
              cursor: 'pointer', boxShadow: '0 4px 12px rgba(27,58,92,0.3)'
            }}>다음 &#8594;</button>
          ) : (
            <button onClick={goRegister} style={{
              padding: '11px 28px', borderRadius: 10, border: 'none',
              background: '#1B3A5C', color: '#fff', fontSize: 14, fontWeight: 700,
              cursor: 'pointer', boxShadow: '0 4px 12px rgba(27,58,92,0.3)'
            }}>차량 등록하러 가기 &#8594;</button>
          )}
        </div>

        {/* Dismiss link */}
        <div style={{ marginTop: 16 }}>
          <button onClick={dismiss} style={{
            background: 'none', border: 'none', color: '#94a3b8',
            fontSize: 12, cursor: 'pointer', textDecoration: 'underline'
          }}>다시 보지 않기</button>
        </div>
      </div>
    </div>
  );
}

export default OnboardingGuide;
